import type { ComponentProps } from 'react';
import ActionButton from '@/components/UI/ActionButton';
import useTimer from '@/hooks/useTimer';

export function Create({
  ...props
}: Omit<ComponentProps<typeof ActionButton>, 'label'>) {
  return (
    <ActionButton
      label="Create Event"
      icon="add-outline"
      variant="success"
      {...props}
    />
  );
}

export function Generate({
  ...props
}: Omit<ComponentProps<typeof ActionButton>, 'label'>) {
  return (
    <ActionButton
      label="Generate Events"
      icon="flash-outline"
      variant="success"
      {...props}
    />
  );
}

export function Filter({
  showMyTeams,
  ...props
}: { showMyTeams?: boolean } & Omit<
  ComponentProps<typeof ActionButton>,
  'label'
>) {
  const hasFilter = showMyTeams;

  return (
    <ActionButton
      forceLabel
      label="Filter / Jump"
      icon="filter-outline"
      variant={hasFilter ? 'info' : 'secondary'}
      {...props}
    />
  );
}

export function Share({
  ...props
}: Omit<ComponentProps<typeof ActionButton>, 'label'>) {
  return (
    <ActionButton
      label="Share"
      icon="share-outline"
      variant="secondary"
      {...props}
    />
  );
}

export function Refresh({
  ...props
}: Omit<ComponentProps<typeof ActionButton>, 'label'>) {
  const [disabled, setDisabled] = useTimer(false);

  return (
    <ActionButton
      disabled={disabled}
      label="Refresh"
      icon="refresh-outline"
      variant="secondary"
      {...props}
      onPress={(e) => {
        setDisabled(true);
        props.onPress?.(e);
      }}
    />
  );
}
